import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixMultilingualEditoradapterV1EditorAdapterUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/editoradapter/v1/component-mapper',
        destPath: '/v1',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_multilingual_entity-mapper';

/** Update localization content with editor data */
export function syncEditorData(payload: object): RequestOptionsFactory<any> {
  function __syncEditorData({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.multilingual.genericconverter.v1.entity_mapper',
      method: 'GET' as any,
      methodFqn:
        'wix.multilingual.editoradapter.v1.EditorAdapter.SyncEditorData',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixMultilingualEditoradapterV1EditorAdapterUrl({
        protoPath: '/v1/pull_data',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __syncEditorData;
}
